
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/site",
      function () {
        return require("private-next-pages/store/site.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/site"])
      });
    }
  